import '&/assets/styles/antd-theme-file.less';
/**
 * import 'core-js/stable';
 * import 'regenerator-runtime/runtime';
 * 等价于 ☞ import 'react-app-polyfill/stable';
 * CRA 官方不常升级 core-js，因此，自行引入 core-js，效果一致。
 * 如果不需要考虑兼容性，可删除。
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// 兼容支持到 IE9，如果不需要可删除。
import 'react-app-polyfill/ie9';
import '&/assets/icon/filled/iconfont.css';
import '&/assets/icon/outlined/iconfont.css';
import '&/assets/styles/index.scss';
import './assets/styles/index.scss';
import React from 'react';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useLocation } from 'react-router-dom';
import { hydrate, render } from 'react-dom';

import reportWebVitals from './reportWebVitals';
import { Provider } from 'mobx-react';

import store from '@/store';
import App from './App';

let requireAll = requireContext => requireContext.keys().map(requireContext);
let svgs = require.context('&/assets/svgicon', false, /\.svg$/);
requireAll(svgs);

window.addEventListener(
    'unhandledrejection',
    event => {
        console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`);
    },
    true
);

(function SentryInit() {
    if (process.env.NODE_ENV === 'production') {
        Sentry.init({
            dsn: 'https://a7606f45224e69ca5a1d317630772c77@sentry-cn.foxitsoftware.cn/4', //'https://f188e1d2ddac4f848131c1ca173e2bb3@sentry.foxithd.com:443/5',
            integrations: [
                // See docs for support of different versions of variation of react router
                // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
                Sentry.reactRouterV6BrowserTracingIntegration({
                    useEffect,
                    useLocation,
                }),
                Sentry.replayIntegration({
                    //stickySession: false,
                    networkDetailAllowUrls: [window.location.origin],
                    mutationBreadcrumbLimit: 30,
                    mutationLimit: 50,
                    maskAllText: false,
                    blockAllMedia: false,
                    maskAllInputs: false,
                }),
            ],
            // integrations: [
            //     new BrowserTracing(),
            //     // new Replay({
            //     //     // Additional SDK configuration goes in here, for example:
            //     //     networkDetailAllowUrls: [window.location.origin],
            //     //     mutationBreadcrumbLimit: 30,
            //     //     mutationLimit: 50,
            //     //     maskAllText: false,
            //     //     blockAllMedia: false,
            //     //     maskAllInputs: false,
            //     // }),
            // ],

            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 0,
            replaysSessionSampleRate: 0,
            replaysOnErrorSampleRate: 1.0,

            maxBreadcrumbs: 8,
            normalizeMaxBreadth: 30,
            autoSessionTracking: false,
            // release:
            //     process.env.REACT_APP_VERSION +
            //     '-' +
            //     process.env.REACT_APP_ENV_TAG,
            environment: process.env.REACT_APP_ENV_TAG,
            // dist: 'test-12-12',
            beforeSend(event) {
                if (isNeedFilter(event)) {
                    return null;
                }
                return event;
            },
            // debug: true,
            ignoreErrors: [
                // Random plugins/extensions
                'top.GLOBALS',
                // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'http://tt.epicplay.com',
                "Can't find variable: ZiteReader",
                'jigsaw is not defined',
                'ComboSearch is not defined',
                'http://loading.retry.widdit.com/',
                'atomicFindClose',
                // Facebook borked
                'fb_xd_fragment',
                // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
                // reduce this. (thanks @acdha)
                // See http://stackoverflow.com/questions/4113268
                'bmi_SafeAddOnload',
                'EBCallBackMessageReceived',
                // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
                'conduitPage',
            ],
            denyUrls: [
                // Facebook flakiness
                /graph\.facebook\.com/i,
                // Facebook blocked
                /connect\.facebook\.net\/en_US\/all\.js/i,
                // Woopra flakiness
                /eatdifferent\.com\.woopra-ns\.com/i,
                /static\.woopra\.com\/js\/woopra\.js/i,
                // Chrome extensions
                /extensions\//i,
                /^chrome:\/\//i,
                // Other plugins
                /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
                /webappstoolbarba\.texthelp\.com\//i,
                /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
            ],
        });
    }
})();

function isNeedFilter(event) {
    let ret = false;

    if (event?.request?.url?.indexOf('http://localhost:45678') === 0) {
        ret = true;
    } else if (
        event?.extra?.__serialized__ &&
        (event.extra.__serialized__.code === 401 ||
            event.extra.__serialized__.message?.[0] === 600)
    ) {
        console.log('zx isNeedFilter', event.extra.__serialized__);
        ret = true;
    }

    return ret;
}
const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
    hydrate(
        <Provider {...store}>
            <App />
        </Provider>,
        rootElement
    );
} else {
    render(
        <Provider {...store}>
            <App />
        </Provider>,
        rootElement
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
